import React from 'react';
import PropTypes from 'prop-types';
import DefaultSelectV2 from '../DefaultSelectV2';

const SimNaoSelectV2 = ({ error, label, name, onChange, value, disabled, isRequired }) => {
  const options = [
    { id: 'SIM', descricao: 'Sim' },
    { id: 'NAO', descricao: 'Não' }
  ];
  return (
    <DefaultSelectV2
      error={error} isRequired={isRequired} label={label} name={name} showEmpty
      onSelect={onChange} options={options} value={value}
      handlerOption={option => option.descricao} disabled={disabled}
    />
  );
};

SimNaoSelectV2.propTypes = {
  error: PropTypes.bool, label: PropTypes.string.isRequired, name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired, value: PropTypes.string, disabled: PropTypes.bool, isRequired: PropTypes.bool
};
SimNaoSelectV2.defaultProps = { value: '' };
export default SimNaoSelectV2;
